import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FormPollResults from "../components/polls/FormPollResults";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";

/**
 * Page de résultats pour les sondages formulaires
 */
export default function Results() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <ProductHeader productType="form" showAuth={true} />
      <div className="flex flex-1">
        <ProductSidebar productType="form" />
        <div className="flex-1">
          <FormPollResults idOrSlug={slug!} />
        </div>
      </div>
    </div>
  );
}
